<template>
  <div class="hidden sm:block">
    <nav class="flex items-center gap-2" aria-label="Tabs">
      <ClientOnly>
        <NuxtLink
          v-for="item in navigation"
          :key="item.name"
          :to="item.href"
          :external="item.external"
          :target="item.external ? '_blank' : undefined"
          :class="[
            item.current ? 'text-p-500' : 'text-grey-300 hover:text-white',
            'group flex items-center gap-1.5 px-0.5 py-3 text-xs font-medium transition-colors duration-200 lg:px-2',
          ]"
          :aria-current="item.current ? 'page' : undefined"
        >
          <Icon
            :name="item.icon"
            :class="[
              item.current
                ? 'text-p-500'
                : 'text-grey-300 group-hover:text-white',
              'size-5 transition-colors duration-200',
            ]"
            aria-hidden="true"
          />
          <span class="mt-1 flex items-center justify-center gap-1">
            {{ item.name }}

            <Icon
              v-if="item.external"
              name="share-03"
              class="size-3"
              aria-hidden="true"
            />
          </span>
        </NuxtLink>
      </ClientOnly>
    </nav>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/common/Icon.vue'
import type { TTopbarNavigationItem } from '~/src/types/navigation'

defineProps<{ navigation: TTopbarNavigationItem[] }>()
</script>
